import React, { useState, useEffect } from "react";
import Header from "../../Components/clubDashboard/Header/Header";
import combinedServices from "../../shared/services/user-service";
import { useParams } from "react-router-dom";
import getLocalData from "../../shared/localStorage/getData";
import Swal from "sweetalert2";
import getRemoveData from "../../shared/localStorage/removeData";

const ScoreTable = () => {
  const [fastTimeEnabled, setFastTimeEnabled] = useState(false);
  const [userId, setUserId] = useState(0);
  const [seriesData, setSeriesData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const { id: seriesId } = useParams();

  const scoringOptions = [
    { value: "", label: "" },
    { value: "400", label: "1st Place-400 points" },
    { value: "300", label: "2nd Place-300 points" },
    { value: "225", label: "3rd Place-225 points" },
    { value: "169", label: "4th Place-169 points" },
    { value: "127", label: "5th Place-127 points" },
    { value: "96", label: "6th Place-96 points" },
    { value: "72", label: "7th Place-72 points" },
    { value: "54", label: "8th Place-54 points" },
    { value: "25", label: "Did Not Finish(DNF)-25 points" },
    { value: "0", label: "Did Not Start(DNS)-0 points" },
    { value: "-1", label: "Disqualified(DQ)-0 points" },
  ];

  useEffect(() => {
    const fetchUserData = async () => {
      if (getLocalData("user_info", "isLogin")) {
        try {
          const userInfo = getLocalData("user_info", "all").userData
            .login_user_detail.data.user;
          setUserId(userInfo.id);

          const data = {
            user_id: userInfo.id,
            clubs: true,
            events: true,
            district: true,
          };

          const profileResponse = await combinedServices.getProfileDetails(
            data
          );
          if (profileResponse.status === 401) {
            Swal.fire(profileResponse.msg, "Please Re-login", "warning").then(
              () => {
                getRemoveData("user_info");
                localStorage.clear();
                window.location.href = "/login";
              }
            );
          }
        } catch (err) {
          console.error("Error fetching user data:", err);
        }
      }
    };

    fetchUserData();
  }, []);

  useEffect(() => {
    const fetchSeriesData = async () => {
      if (!userId || !seriesId) return;

      try {
        setLoading(true);
        const response = await combinedServices.getSeriesAndScore(seriesId);
        if (response.status === 200) {
          setSeriesData(response.data);
        } else {
          setError(response.msg || "Failed to fetch series data");
        }
      } catch (err) {
        setError(err.message || "An error occurred");
        console.error("Error fetching series data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchSeriesData();
  }, [userId, seriesId]);

 const handleScoreChange = async (classId, participantId, eventId, newScore) => {
  try {
    const response = await combinedServices.scoreSeries({
      series_id: seriesId,
      class_id: classId,
      participant_id: participantId,
      event_id: eventId,
      score: newScore,
    });

    if (response.data.status === 200) {
      setSeriesData((prevData) =>
        prevData.map((classItem) => {
          if (classItem.classId === classId) {
            return {
              ...classItem,
              participants: classItem.participants.map((participant) => {
                // Find if this participant has the score with matching participantId
                const scoreKey = `race_${eventId}`;
                if (participant.scores[scoreKey]?.participantId === participantId) {
                  const updatedScores = {
                    ...participant.scores,
                    [scoreKey]: {
                      ...participant.scores[scoreKey],
                      points: parseInt(newScore) || 0
                    }
                  };

                  return {
                    ...participant,
                    scores: updatedScores,
                    total: Object.values(updatedScores).reduce(
                      (sum, score) => sum + (score.participant ? score.points : 0),
                      0
                    )
                  };
                }
                return participant;
              }),
            };
          }
          return classItem;
        })
      );
    } else {
      Swal.fire("Error", response.msg || "Failed to update score", "error");
    }
  } catch (err) {
    Swal.fire("Error", err.message || "Failed to update score", "error");
  }
};

  if (loading) {
    return (
      <>
        <Header />
        <div className="dbRight">
          <div className="dbMid dbInner">
            <div className="flexBox spacebetween topHdBox">
              <div className="score">
                <div className="loading">Loading series data...</div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  if (error) {
    return (
      <>
        <Header />
        <div className="dbRight">
          <div className="dbMid dbInner">
            <div className="flexBox spacebetween topHdBox">
              <div className="score">
                <div className="error">{error}</div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <Header />
      <div className="dbRight">
        <div className="dbMid dbInner">
          <div className="flexBox spacebetween topHdBox">
            <div className="score">
              <div
                className="bradcrumb"
                style={{ backgroundColor: "rgb(28, 96, 166)" }}
              >
                <a href="/">Home</a>
                <a href="/event-management">Event Management</a>
                <a href="">Score Series</a>
              </div>

              {seriesData.map((classItem, classIndex) => (
                <div key={classIndex} style={{marginTop:"20px"}}>
                  <table
                    className="tablescore"
                    style={{
                      width: "100%",
                      tableLayout: "fixed",
                      borderCollapse: "collapse",
                    }}
                  >
                    <thead>
                      <tr>
                        <th
                          style={{
                            width: "20%",
                            border: "1px solid #ddd",
                            padding: "8px",
                            backgroundColor: "#f2f2f2",
                            textAlign: "center",
                          }}
                        >
                          {classItem.className}
                        </th>
                        {Object.keys(
                          classItem.participants[0]?.scores || {}
                        ).map((raceKey, index) => (
                          <th
                            key={index}
                            className="tac"
                            style={{
                              width: "15%",
                              border: "1px solid #ddd",
                              padding: "8px",
                              backgroundColor: "#f2f2f2",
                              textAlign: "center",
                            }}
                          >
                             {classItem.participants[0].scores[raceKey].eventName}
                          </th>
                        ))}
                        <th
                          className="tac"
                          style={{
                            width: "10%",
                            border: "1px solid #ddd",
                            padding: "8px",
                            backgroundColor: "#f2f2f2",
                            textAlign: "center",
                          }}
                        >
                          Total
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {classItem.participants.map(
                        (participant, participantIndex) => (
                          <tr key={participantIndex}>
                            <td
                              style={{
                                width: "20%",
                                border: "1px solid #ddd",
                                padding: "8px",
                                textAlign: "center",
                                wordWrap: "break-word",
                              }}
                            >
                              {participant.name}
                            </td>
                            {Object.entries(participant.scores).map(
                              ([raceKey, scoreData], raceIndex) => (
                                <td
                                  key={raceIndex}
                                  style={{
                                    width: "15%",
                                    border: "1px solid #ddd",
                                    padding: "8px",
                                    textAlign: "center",
                                    wordWrap: "break-word",
                                  }}
                                >
                                  {scoreData.participant ? (
                                    <div className="score-inputs-wrapper">
                                      <div className="select-wrapper scoreinputbox">
                                        {scoreData.isEditable ? (<input
                                          type="text"
                                          className="form-control"
                                          value={scoreData.points}
                                          onChange={(e) =>
                                            handleScoreChange(
                                              classItem.classId,
                                              scoreData.participantId,
                                              scoreData.eventId,
                                              e.target.value
                                            )
                                          }
                                          style={{
                                            width: "100%",
                                            boxSizing: "border-box",
                                          }}
                                        />): (
                                          <span>{scoreData.points}</span>
                                        )}
                                        {/* <select
                                          tabIndex="-1"
                                          value={scoreData.points}
                                          onChange={(e) =>
                                            handleScoreChange(
                                              classItem.classId,
                                              scoreData.participantId,
                                              scoreData.eventId,
                                              e.target.value
                                            )
                                          }
                                          style={{
                                            width: "100%",
                                            boxSizing: "border-box",
                                          }}
                                        >
                                          {scoringOptions.map(
                                            (option, optionIndex) => (
                                              <option
                                                key={optionIndex}
                                                value={option.value}
                                              >
                                                {option.label}
                                              </option>
                                            )
                                          )}
                                        </select> */}
                                      </div>
                                      <div className="fast-time-input-container">
                                        <input
                                          className="fast-time-input"
                                          type="text"
                                          value={scoreData.points}
                                          style={{
                                            borderRadius: "0.25rem",
                                            width: "35px",
                                            marginLeft: "3px",
                                            border: "1.5px solid lightgray",
                                            display: fastTimeEnabled
                                              ? "block"
                                              : "none",
                                            textAlign: "center",
                                            fontSize: "12px",
                                          }}
                                        />
                                      </div>
                                    </div>
                                  ) : (
                                    <span>-</span>
                                  )}
                                </td>
                              )
                            )}
                            <td
                              style={{
                                width: "10%",
                                border: "1px solid #ddd",
                                padding: "8px",
                                textAlign: "center",
                                fontWeight: 600,
                                wordWrap: "break-word",
                              }}
                            >
                              {participant.total}
                            </td>
                          </tr>
                        )
                      )}
                    </tbody>
                  </table>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ScoreTable;
